/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ServiceAgreementPropertiesType = {
    SafeDepositBox: 'SAFE_DEPOSIT_BOX',
    WealthPlanning: 'WEALTH_PLANNING'
} as const;
export type ServiceAgreementPropertiesType = typeof ServiceAgreementPropertiesType[keyof typeof ServiceAgreementPropertiesType];


export function instanceOfServiceAgreementPropertiesType(value: any): boolean {
    for (const key in ServiceAgreementPropertiesType) {
        if (Object.prototype.hasOwnProperty.call(ServiceAgreementPropertiesType, key)) {
            if (ServiceAgreementPropertiesType[key as keyof typeof ServiceAgreementPropertiesType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ServiceAgreementPropertiesTypeFromJSON(json: any): ServiceAgreementPropertiesType {
    return ServiceAgreementPropertiesTypeFromJSONTyped(json, false);
}

export function ServiceAgreementPropertiesTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceAgreementPropertiesType {
    return json as ServiceAgreementPropertiesType;
}

export function ServiceAgreementPropertiesTypeToJSON(value?: ServiceAgreementPropertiesType | null): any {
    return value as any;
}

export function ServiceAgreementPropertiesTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): ServiceAgreementPropertiesType {
    return value as ServiceAgreementPropertiesType;
}

